import { createAction } from '@reduxjs/toolkit';

export const ADD_CARD_ACTION_TYPE = 'saga/addCard';
export const addCardAction = createAction(ADD_CARD_ACTION_TYPE);
